import { NEUTRAL, RAG } from 'features/dashboard/charts/scoreColour'
import { UPCOMING_TINT } from 'features/taskManagement/taskProgressBuckets'

export const REMEDIAL_PROGRESS_BUCKETS = [
  { key: 'openOnTrack', label: 'Open', tint: UPCOMING_TINT, help: 'Still being dealt with, and not past its due date yet.' },
  { key: 'overdue', label: 'Overdue', tint: RAG.critical.fg, help: 'Still open, and the due date has passed.' },
  { key: 'resolvedLate', label: 'Resolved late', tint: RAG.high.fg, help: 'Put right, but after the due date.' },
  { key: 'resolvedOnTime', label: 'Resolved on time', tint: RAG.low.fg, help: 'Put right on or before the due date.' },
  { key: 'resolvedNoDate', label: 'Resolved, no due date', tint: RAG.none.fg, help: 'Put right, but it never had a due date, so it cannot count towards the on-time rate.' },
  { key: 'dismissedAfterApproval', label: 'Dismissed after approval', tint: NEUTRAL.faint, help: 'Accepted as a real remedial, then closed without any work, for example because it was no longer needed. AI suggestions turned down at review are not counted here or anywhere above.' },
]

const derive = row => {
  const cohort = row?.cohort
  if (cohort) {
    return {
      openOnTrack: Number(cohort.open ?? 0),
      overdue: Number(cohort.overdue ?? 0),
      resolvedLate: Number(cohort.resolvedLate ?? 0),
      resolvedOnTime: Number(cohort.resolvedOnTime ?? 0),
      resolvedNoDate: Number(cohort.resolvedNoDate ?? 0),
      dismissedAfterApproval: Number(cohort.dismissedAfterAccept ?? 0),
    }
  }
  const live = Number(row?.live ?? 0)
  const overdue = Number(row?.overdue ?? 0)
  return {
    openOnTrack: Math.max(0, live - overdue),
    overdue,
    resolvedLate: Number(row?.resolvedLate ?? 0),
    resolvedOnTime: Number(row?.resolvedOnTime ?? 0),
    resolvedNoDate: Number(row?.resolvedWithoutDueDate ?? 0),
    dismissedAfterApproval: Number(row?.dismissedAfterAccept ?? 0),
  }
}

export const remedialBucketsFromRow = row => {
  const counts = derive(row)
  return REMEDIAL_PROGRESS_BUCKETS.map(b => ({ ...b, count: counts[b.key] }))
}

export const remedialBucketTotal = row =>
  Object.values(derive(row)).reduce((sum, n) => sum + n, 0)

export const remedialBarRow = row => ({ ...row, ...derive(row) })
